import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '/api/dataview'
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const providersService = {
  getProviders,
  getAdvisorsForProvider,
  getAdvisors,
  getAdvisorCodes // ✅ add this
};

async function getAdvisorCodes(advisorId) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/partner-codes', { id: advisorId }, requestOptions);

  return response.data;
}

async function getProviders() {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/providers', {}, requestOptions);
  return response.data; // expects array of providers
}

async function getAdvisorsForProvider(providerId) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/provider-partner-codes',
    { id: providerId }, // ✅ THIS IS THE FIX
    requestOptions
  );

  return response.data;
}

async function getAdvisors() {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/partners', {}, requestOptions);
  return response.data;
}
